export function splitPascalCase(key: string | undefined): string {
  if (!key) {
    return ''
  }

  const spaceThenUpperCaseLetterRegex = /( )([A-Z])/g
  const letterFollowedByNumberRegex = /([a-zA-Z])(\d)/g
  const upperCaseLetterRegex = /([A-Z])/g

  // First remove spaces before upper case letters so we dont end up with double spaces
  const removedSpacesBeforeUpper = key.replace(spaceThenUpperCaseLetterRegex, '$2')
  const addedSpacesBetweenUpper = removedSpacesBeforeUpper.replace(upperCaseLetterRegex, ' $1')
  return addedSpacesBetweenUpper.replace(letterFollowedByNumberRegex, '$1 $2').trim()
}
